import React from "react";

const Footer = () => {
  return (
    <div className="nk-footer">
      <div className="container-fluid">
        <div className="nk-footer-wrap">
          <div className="nk-footer-copyright ms-auto"> &copy; 2023 Niteon. Powered by Softweb Digital Ltd.</div>
        </div>
      </div>
    </div>
  );
};
export default Footer;
